import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { select } from '@angular-redux/store';

import { RegisterWithEmailDTO, WidgetOptionsForEmailRegister } from '@ridango/core';

import { Observable } from 'rxjs';

import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-signup-form',
    templateUrl: './signup-form.component.html',
    styleUrls: ['./signup-form.component.scss']
})
export class SignUpFormComponent {
    @select(['application', 'highContrast']) highContrast$: Observable<boolean>;

    selectedSignUpMethod = 'selectedSignUpEmail';

    @Input() options: WidgetOptionsForEmailRegister;
    @Input() captchaToggleAllowed = false;
    @Output() registerEvent = new EventEmitter<RegisterWithEmailDTO>();

    constructor(@Inject('ENV') public env: Env) {}

    forwardRegisterEvent(payload: RegisterWithEmailDTO): void {
        this.registerEvent.emit(payload);
    }

    setSelectedSignUpMethod(value: string): void {
        this.selectedSignUpMethod = value;
    }

    showSelectedSignUpMethodForm(method: string): boolean {
        return this.selectedSignUpMethod === method;
    }
}
